import "./Service_pages.scss";
import img from "./services/Braces.png"; // Replace with your actual image path
import img2 from "./services/dental.png";
import { FaCheckCircle, FaTooth, FaThumbsUp, FaUserMd, FaHeart, FaShieldAlt, FaClinicMedical, FaLaptopMedical, FaUtensils, FaQuestionCircle } from 'react-icons/fa';
import { MdOutlineStarPurple500, MdOutlineHealthAndSafety, MdOutlineVisibility, } from "react-icons/md";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";

const BracesTreatment = () => {

  const types = [
    {
      title: "Traditional Metal Braces",
      icon: <FaTooth />,
      desc: "The most common orthodontic treatment. Consists of high-grade stainless steel brackets and wires. Modern versions are smaller, more comfortable, and highly efficient at moving teeth.",
    },
    {
      title: "Ceramic Braces",
      icon: <MdOutlineStarPurple500 />,
      desc: "Uses tooth-colored or clear brackets that blend with your natural teeth. They are less noticeable than metal braces while providing the same effective level of alignment correction.",
    },
    {
      title: "Self-Ligating Braces",
      icon: <MdOutlineHealthAndSafety />,
      desc: "Features specialized brackets that hold the archwire without elastic bands. This design reduces friction on the teeth and may even shorten the overall treatment time in many cases.",
    },
    {
      title: "Lingual Braces",
      icon: <MdOutlineVisibility />,
      desc: "Placed on the inner surface (tongue-side) of the teeth, making them virtually invisible to others. This requires specialized orthodontic expertise for a completely discreet treatment.",
    },
  ];

  const benefitsTable = [
    {
      category: "Oral Health",
      benefit: "Improved Hygiene",
      description: "Properly aligned teeth are significantly easier to clean, reducing the long-term risk of cavities and gum disease.",
    },
    {
      category: "Function",
      benefit: "Better Bite Function",
      description: "Correcting bite problems improves chewing efficiency and reduces unnecessary strain on the jaw joints.",
    },
    {
      category: "Aesthetics",
      benefit: "Straighter Smile",
      description: "Gradually aligns crooked or crowded teeth, creating a more balanced, attractive, and symmetrical smile.",
    },
    {
      category: "Confidence",
      benefit: "Boosted Self-Esteem",
      description: "A straighter smile significantly boosts confidence in social interactions and improves overall quality of life.",
    },
    {
      category: "Longevity",
      benefit: "Long-Term Dental Health",
      description: "Helps prevent excessive tooth wear and other complex dental problems associated with chronic misalignment.",
    },
  ];

  const reasons = [
    {
      icon: <FaUserMd />,
      title: 'Experienced Orthodontists',
      description: 'Our clinic features specialists who create personalized treatment plans designed for optimal clinical results.'
    },
    {
      icon: <FaLaptopMedical />,
      title: 'Advanced Ortho Technology',
      description: 'We utilize digital dental scanners, CBCT imaging, and advanced planning software for high-precision outcomes.'
    },
    {
      icon: <FaHeart />,
      title: 'Patient-Friendly Care',
      description: 'We prioritize comfort and provide a supportive environment for both children and adults during their journey.'
    },
    {
      icon: <FaThumbsUp />,
      title: 'Customized Treatment',
      description: 'No two smiles are the same. We tailor brackets and wire sequences to your specific dental anatomy.'
    },
    {
      icon: <FaShieldAlt />,
      title: 'High-Quality Materials',
      description: 'We use only top-tier orthodontic components to ensure durability and effective tooth movement.'
    },
    {
      icon: <FaClinicMedical />,
      title: 'Comprehensive Services',
      description: 'From initial consultation to final retention, we provide all orthodontic services in one location at HSR Layout.'
    }
  ];

  return (
    <>
      <div className="service1-section">
        <Helmet>
          <title>Braces Treatment in HSR Layout | Orthodontist in Bengaluru</title>
          <meta
            name="description"
            content="Straighten your smile with advanced Braces Treatment in HSR Layout. Kosmix Dental Clinic offers metal, ceramic, and self-ligating braces for kids and adults."
          />
          <link
            rel="canonical"
            href="https://www.kosmixdentalclinic.com/services/braces-treatment-in-hsr-layout"
          />
        </Helmet>

        {/* HERO SECTION */}
        <div className="hero">
          <h1 className="service1-title-text" data-aos="fade-down" data-aos-delay="200" style={{ fontFamily: 'initial' }}>
            Braces Treatment in HSR Layout, Bengaluru
          </h1>

          <div className="hero-content">
            <div className="hero-image" data-aos="zoom-in-right" data-aos-delay="200" data-aos-duration="800">
              <img src={img} alt="Orthodontic Braces Treatment" />
            </div>

            <div className="hero-text" data-aos="zoom-in-left" data-aos-delay="200" data-aos-duration="800">
              <p>
                Crooked or misaligned teeth can affect both oral health and self-confidence. <strong>Braces</strong> remain one of the most effective orthodontic treatments used to straighten teeth, correct bite problems, and improve overall dental alignment.
              </p>
              <p>
                At Kosmix Dental Clinic in HSR Layout, Bengaluru, we offer advanced braces treatments designed to gently move teeth into their ideal positions. Our experienced orthodontic specialists carefully evaluate each patient’s condition to create personalized treatment plans.
              </p>
              <p>
                Modern orthodontic technology allows braces to be more comfortable and effective than ever before. With proper care, braces help patients achieve a healthier bite and a beautifully aligned smile that lasts a lifetime.
              </p>
            </div>
          </div>
        </div>

        {/* WHAT ARE BRACES */}
        <div className="content" data-aos="fade-up" data-aos-delay="300" >
          <SectionTitle title="What Are Braces?" />
          <div className="text_first" style={{
            background: 'linear-gradient(135deg, #fdf6ec, #ffffff)',
            padding: '35px',
            borderRadius: '16px',
            borderTop: '3px dashed #561b0f',
            borderBottom: '3px dashed #561b0f',
            boxShadow: 'inset 0 0 20px rgba(86, 27, 15, 0.05)',
            margin: '20px auto 40px',
            maxWidth: '1000px'
          }}>
            <p1>
              Braces are orthodontic appliances used to correct misaligned teeth and jaw irregularities. They work by applying continuous gentle pressure over time, gradually moving teeth into proper alignment. They treat a wide range of issues including crooked teeth, crowded teeth, gaps, overbites, underbites, crossbites, and open bites.
            </p1>
          </div>
        </div>

        {/* ORTHO GUIDANCE HUB */}
        <section className="ortho-guidance-hub" data-aos="fade-up">
          <div className="guidance-container">
            <div className="guidance-main-header">
              <SectionTitle title="Patient Guidance for Braces" />
              <p className="guidance-subtitle">Essential information to help you identify the need for braces and maintain them effectively throughout your treatment journey.</p>
            </div>

            <div className="guidance-sections-grid">
              <div className="guidance-card signs-card" data-aos="fade-right" data-aos-delay="200">
                <div className="card-header">
                  <div className="header-icon"><FaQuestionCircle /></div>
                  <h3>Signs You Need Braces</h3>
                </div>
                <p className="card-desc">Orthodontic treatment can benefit both children and adults. Common indicators include:</p>
                <ul className="guidance-list">
                  <li><FaCheckCircle className="li-icon" /> <span>Crooked, overlapping, or crowded teeth.</span></li>
                  <li><FaCheckCircle className="li-icon" /> <span>Visible gaps or spacing issues between teeth.</span></li>
                  <li><FaCheckCircle className="li-icon" /> <span>Difficulty chewing or biting comfortably.</span></li>
                  <li><FaCheckCircle className="li-icon" /> <span>Teeth that protrude noticeably outward.</span></li>
                  <li><FaCheckCircle className="li-icon" /> <span>Persistent jaw pain or discomfort.</span></li>
                  <li><FaCheckCircle className="li-icon" /> <span>Uneven bite alignment where teeth don't meet properly.</span></li>
                </ul>
              </div>

              <div className="guidance-card diet-card" data-aos="fade-left" data-aos-delay="400">
                <div className="card-header">
                  <div className="header-icon"><FaUtensils /></div>
                  <h3>Care & Diet Guide</h3>
                </div>
                <p className="card-desc">Maintaining hygiene and avoiding certain foods is critical for orthodontic success:</p>
                <ul className="guidance-list">
                  <li><FaCheckCircle className="li-icon" /> <span><strong>Avoid:</strong> Hard candies, ice, nuts, and popcorn.</span></li>
                  <li><FaCheckCircle className="li-icon" /> <span><strong>Avoid Sticky:</strong> Caramel, taffy, and chewing gum.</span></li>
                  <li><FaCheckCircle className="li-icon" /> <span><strong>Hygiene:</strong> Brush after every meal and use interdental brushes.</span></li>
                  <li><FaCheckCircle className="li-icon" /> <span><strong>Protection:</strong> Choose softer foods to protect wires and brackets.</span></li>
                  <li><FaCheckCircle className="li-icon" /> <span><strong>Retention:</strong> Always wear retainers as recommended after removal.</span></li>
                </ul>
              </div>
            </div>
          </div>
        </section>

        {/* TREATMENT PROCESS TIMELINE */}
        <section className="timeline-container">
          <div className="content" data-aos="fade-up">
            <SectionTitle title="The Braces Treatment Process" />
            <p className="text_first" style={{
              background: '#fdf6ec',
              padding: '20px 40px',
              borderRadius: '40px',
              borderWidth: '0 4px 0 4px',
              borderStyle: 'solid',
              borderColor: '#561b0f',
              margin: '0 auto 40px',
              maxWidth: '800px',
              boxShadow: '0 8px 20px rgba(86, 27, 15, 0.06)'
            }}>
              Our step-by-step approach ensures proper alignment and successful results:
            </p>
          </div>

          <div className="timeline-step" data-aos="fade-right">
            <div className="timeline-icon">🩺</div>
            <div className="timeline-content">
              <h3>Initial Consultation</h3>
              <p>Examination of teeth, jaw alignment, and oral health using digital X-rays and dental impressions for evaluation.</p>
            </div>
            <div className="timeline-icon">1</div>
          </div>

          <div className="timeline-step" data-aos="fade-left">
            <div className="timeline-icon">📊</div>
            <div className="timeline-content">
              <h3>Treatment Planning</h3>
              <p>Creation of a personalized plan outlining the expected duration and specific steps for your orthodontic journey.</p>
            </div>
            <div className="timeline-icon">2</div>
          </div>

          <div className="timeline-step" data-aos="fade-right">
            <div className="timeline-icon">🛠️</div>
            <div className="timeline-content">
              <h3>Placement of Braces</h3>
              <p>Brackets are attached using special dental adhesive, and archwires are connected to guide tooth movement.</p>
            </div>
            <div className="timeline-icon">3</div>
          </div>

          <div className="timeline-step" data-aos="fade-left">
            <div className="timeline-icon">📅</div>
            <div className="timeline-content">
              <h3>Regular Adjustments</h3>
              <p>Periodic visits every 4–6 weeks for wire adjustments to ensure steady and controlled progress.</p>
            </div>
            <div className="timeline-icon">4</div>
          </div>

          <div className="timeline-step" data-aos="fade-right">
            <div className="timeline-icon">✨</div>
            <div className="timeline-content">
              <h3>Removal & Retention</h3>
              <p>Braces are removed once ideal alignment is reached, and a retainer is provided to maintain your new smile.</p>
            </div>
            <div className="timeline-icon">5</div>
          </div>
        </section>

        {/* TYPES OF BRACES GRID */}
        <section className="crown-types-section">
          <div className="content" data-aos="fade-up">
            <SectionTitle title="Types of Braces We Offer" />
            <p1 className="text_first" style={{
              background: 'rgba(255, 255, 255, 0.9)',
              padding: '25px 35px',
              borderRadius: '12px',
              borderLeft: '8px solid #561b0f',
              boxShadow: '5px 5px 0px rgba(86, 27, 15, 0.1)',
              margin: '0 auto 40px',
              maxWidth: '850px',
              display: 'block'
            }}>
              We provide several options allowing patients to choose what best fits their lifestyle and aesthetic preferences.
            </p1>
          </div>

          <div className="crown-grid">
            {types.map((item, idx) => (
              <div className="crown-card" key={idx} data-aos="zoom-in" data-aos-delay={idx * 200}>
                <div className="icon">{item.icon}</div>
                <h3>{item.title}</h3>
                <p>{item.desc}</p>
              </div>
            ))}
          </div>
        </section>

        {/* COMPREHENSIVE BENEFITS TABLE */}
        <section className="benefits-section" data-aos="fade-up">
          <div className="benefits-wrapper">
            <div className="content">
              <h2 className="section-title">Comprehensive Benefits of Braces</h2>
            </div>
            <div className="table-responsive">
              <table className="styled-table">
                <thead>
                  <tr>
                    <th>Category</th>
                    <th>Specific Benefit</th>
                    <th>Clinical Impact</th>
                  </tr>
                </thead>
                <tbody>
                  {benefitsTable.map((item, index) => (
                    <tr key={index}>
                      <td className="category-cell">
                        {index === 0 || item.category !== benefitsTable[index - 1].category ? item.category : ""}
                      </td>
                      <td>{item.benefit}</td>
                      <td>{item.description}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </section>

        {/* TECHNOLOGY & AGE GROUPS */}
        <section className="why-choose-us">
          <div className="wrapper">
            <div className="image-side" data-aos="zoom-in" data-aos-delay="100">
              <img src={img2} alt="Modern Orthodontic Clinic" />
            </div>

            <div className="text-side" data-aos="fade-up" data-aos-delay="300" style={{
              background: '#fdf6ec',
              padding: '40px',
              borderRadius: '16px',
              border: '1px solid rgba(86, 27, 15, 0.1)',
              boxShadow: '10px 10px 0px #561b0f',
              position: 'relative',
              marginBottom: '10px'
            }}>
              <h2>Advanced Tech for All Age Groups</h2>
              <p style={{ color: 'black' }}>
                At <strong>Kosmix Dental Clinic</strong>, we treat patients of all ages, ensuring that orthodontic care is effective whether you are 7 or 70.
              </p>

              <div className="doctor-info" data-aos="fade-up" data-aos-delay="400">
                <h3>Ortho for Kids & Teens</h3>
                <p style={{ fontSize: '14px', marginBottom: '15px' }}>Early evaluation allows us to identify alignment issues while jaws are still developing, often preventing complex surgery later.</p>

                <h3>Ortho for Adults</h3>
                <p style={{ fontSize: '14px' }}>Modern options like ceramic braces or clear aligners make adult treatment discreet, correcting long-standing bite issues comfortably.</p>
              </div>

              <p style={{ color: 'black', marginTop: '20px' }}>
                We use <strong>CBCT imaging, Digital Scanners,</strong> and <strong>Planning Software</strong> to deliver accurate treatment and improved patient comfort.
              </p>
            </div>
          </div>
        </section>

        {/* DETAILED FAQ SECTION */}
        <section className="pricing-section" data-aos="fade-up">
          <div className="pricing-content">
            <div className="text-area">
              <div className="content" data-aos="fade-up">
                <SectionTitle title="Frequently Asked Questions" />
                <div className="faq-grid" style={{ display: 'grid', gridTemplateColumns: '1fr', gap: '20px', marginTop: '20px' }}>
                  <div style={{ background: '#fdf6ec', padding: '25px', borderRadius: '12px', borderLeft: '6px solid #561b0f', boxShadow: '0 6px 15px rgba(86, 27, 15, 0.05)' }}>
                    <p style={{ margin: 0, color: '#3d2a1e', fontSize: '16px' }}><strong>How long does treatment take?</strong><br />Most treatments take between 12 to 24 months depending on complexity.</p>
                  </div>
                  <div style={{ background: '#ffffff', padding: '25px', borderRadius: '12px', borderRight: '6px solid #561b0f', boxShadow: '0 6px 15px rgba(86, 27, 15, 0.05)' }}>
                    <p style={{ margin: 0, color: '#3d2a1e', fontSize: '16px' }}><strong>Are braces painful?</strong><br />You may feel mild discomfort after adjustments, but it usually subsides within a few days.</p>
                  </div>
                  <div style={{ background: '#fdf6ec', padding: '25px', borderRadius: '12px', borderLeft: '6px solid #561b0f', boxShadow: '0 6px 15px rgba(86, 27, 15, 0.05)' }}>
                    <p style={{ margin: 0, color: '#3d2a1e', fontSize: '16px' }}><strong>Can adults get braces?</strong><br />Yes, braces are suitable for patients of all ages who want to correct alignment.</p>
                  </div>
                  <div style={{ background: '#ffffff', padding: '25px', borderRadius: '12px', borderRight: '6px solid #561b0f', boxShadow: '0 6px 15px rgba(86, 27, 15, 0.05)' }}>
                    <p style={{ margin: 0, color: '#3d2a1e', fontSize: '16px' }}><strong>How often are the visits?</strong><br />Typically every 4 to 6 weeks for adjustments and progress monitoring.</p>
                  </div>
                  <div style={{ background: '#fdf6ec', padding: '25px', borderRadius: '12px', borderLeft: '6px solid #561b0f', boxShadow: '0 6px 15px rgba(86, 27, 15, 0.05)' }}>
                    <p style={{ margin: 0, color: '#3d2a1e', fontSize: '16px' }}><strong>Will it affect speech?</strong><br />You might notice a slight change initially, but your mouth adapts quickly.</p>
                  </div>
                </div>
              </div>
            </div>

            <div className="price-cards">
              <div className="price-card">
                <div className="tag">Compliance</div>
                <h3 className="price">Ortho Success</h3>
                <p className="desc">Keys to a faster treatment time</p>
                <ul className="details">
                  <li>● Excellent Oral Hygiene</li>
                  <li>● No Broken Brackets</li>
                  <li>● Regular Adjustments</li>
                </ul>
              </div>

              <div className="price-card premium">
                <div className="tag premium-tag">Retention</div>
                <h3 className="price">New Smile</h3>
                <p className="desc">Life after the braces come off</p>
                <ul className="details">
                  <li>● Custom Retainers</li>
                  <li>● Stable Alignment</li>
                  <li>● Confident Social Life</li>
                </ul>
              </div>
            </div>
          </div>
        </section>

        {/* WHY CHOOSE US TIMELINE */}
        <section className="why-kosmix-timeline">
          <div className="content" data-aos="fade-up">
            <SectionTitle title="Why Choose Kosmix for Braces in Bengaluru?" />
            <p1 className="text_first" style={{
              background: 'linear-gradient(to right, #ffffff, #fdf6ec)',
              padding: '25px 40px',
              borderRadius: '50px 0 50px 0',
              border: '2px solid rgba(86, 27, 15, 0.1)',
              boxShadow: '0 10px 25px rgba(86, 27, 15, 0.05)',
              margin: '0 auto 40px',
              maxWidth: '850px',
              display: 'block'
            }}>
              Our reputation for orthodontic excellence is built on a foundation of technology and patient satisfaction:
            </p1>
          </div>
          <div className="timeline">
            {reasons.map((reason, index) => (
              <div className={`timeline-item ${index % 2 === 0 ? 'left' : 'right'}`} key={index}>
                <div className="timeline-icon">{reason.icon}</div>
                <div className="timeline-content" style={{
                  background: 'linear-gradient(145deg, #ffffff, #fdf6ec)',
                  padding: '30px',
                  borderRadius: index % 2 === 0 ? '30px 10px 30px 10px' : '10px 30px 10px 30px',
                  borderTop: '6px solid #561b0f',
                  borderBottom: '2px solid rgba(86, 27, 15, 0.1)',
                  boxShadow: '0 8px 30px rgba(86, 27, 15, 0.08)'
                }}>
                  <h3 style={{ color: '#561b0f', fontWeight: '800', fontSize: '1.3rem', borderBottom: '1px solid rgba(86, 27, 15, 0.1)', paddingBottom: '12px', marginBottom: '14px' }}>{reason.title}</h3>
                  <p style={{ display: window.innerWidth <= 768 ? 'none' : 'block', color: '#3d2a1e', margin: 0, lineHeight: '1.6' }}>
                    {reason.description}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </section>

        {/* FINAL CTA */}
        <section className="cta-section" data-aos='zoom-in'>
          <div className="cta-content">
            <h2>
              Achieve Your Dream Smile <span>Today!</span>
            </h2>
            <p>
              Don't let misaligned teeth hold you back. Experience expert orthodontic care with the latest technology at Kosmix Dental Clinic, HSR Layout.
            </p>
            <div className="cta-buttons">
              <Link to="/#appointment">
                <button className="btn-primary">Book Ortho Consultation</button>
              </Link>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

const SectionTitle = ({ title }) => (
  <h2 className="section-title">{title}</h2>
);

export default BracesTreatment;